module.exports = __webpack_public_path__ + "static/media/Logo.d0d598ca.svg";